import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
    width?:string;
    height?:string;
    myStyle?:string;
    onClick?:any;
}
    
     function Cancel({ color , width , height , myStyle , onClick}: Props): ReactElement {

    return (
        <svg className={myStyle? myStyle : ""} width={width ? width : "24"} height={height ? height : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick && onClick}>
        <path d="M5 19L19 5M19 19L5 5" stroke={color ? color : "black"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default Cancel;